import { Injectable } from '@angular/core';
import { TotalFilter } from 'app/models/filter.models';
import { Totals, TotalsResponse } from 'app/models/totals.models';
import { Observable, map } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class TotalsService {
  constructor(private http: HttpClient) {}

  getTotals(filters?: TotalFilter): Observable<Array<Totals>> {
    return this.http
      .get<TotalsResponse>(`${environment.apiUrl}/api/analytics/v2/citations/department/totals`, {
        params: filters ? filters : {},
      })
      .pipe(
        map((response: TotalsResponse) => [
          { title: 'Total Stops', value: response.totalStops || 0 },
          { title: 'Total Citations', value: response.totalCitations || 0 },
          { title: 'Total Warnings', value: response.totalWarnings || 0 },
        ]),
      );
  }
}
